import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ComplaintsTicktsService } from '../../../services/complaintsTickts.service';
import Swal from 'sweetalert2';
import { DirtyComponent } from 'projects/shared/src/helpers/CanDeactivate/dirty-component';
import { ChangeStatusFormModel } from '../../../models/ChangeStatusFormModel';
import { Lookup } from 'projects/shared/src/models/lookup';

export interface DialogData {
  title: string;
  titleDesc: string;
  btnSubmitTitle: string;
  titleField: string;
  btnClass: string;
  successMsg: string;
  successMsgDesc: string;
  model: {
    ticketId: number,
    actionId: number,
    status: string,
    commen: string
  }
  service: string
  methodName: string
  showReasonList: boolean
}

@Component({
  selector: 'app-complaint-actions',
  standalone: false,

  templateUrl: './complaint-actions.component.html',
})
export class ComplaintActionsComponent extends DirtyComponent {
  dataLoading = false;
  loading = false;
  changeStatusFormModel: ChangeStatusFormModel = new ChangeStatusFormModel()
  override formGroup: FormGroup = new FormGroup({});
  reasonsList: Lookup[] = [];

  constructor(
    override dialogRef: MatDialogRef<ComplaintActionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: ComplaintsTicktsService,
    translate: TranslateService
  ) {
    super(translate);
  }

  ngOnInit(): void {
    this.buildForm();
    this.getCloseReasons();
  }

  getCloseReasons() {
    this.dataLoading = true;
    this.service.getCloseReasons(this.data.model.ticketId).subscribe(
      (data: any) => {
        this.dataLoading = false;
        this.reasonsList = data as Lookup[];
        // if (this.reasonsList.length) {
        //   this.formGroup.controls.type.setValue(this.reasonsList[0]);
        // }
      }, (err: any) => {
        this.dataLoading = false;
      });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      CloseReasonId: [null],
      OtherComplaintCloseReason: [null],
    });
  }

  saveRecord() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.loading = true;
      this.changeStatusFormModel = {
        ticketId: this.data.model.ticketId,
        actionId: this.data.model.actionId,
        status: this.data.model.status,
        CloseReasonId: this.formGroup.controls['CloseReasonId'].value?.id,
        OtherComplaintCloseReason: this.formGroup.controls['OtherComplaintCloseReason'].value
      }
      if (!this.data.showReasonList) {
        this.changeStatusFormModel.comment = this.formGroup.controls['OtherComplaintCloseReason'].value
      }
      const service: any = this.data.service;
      const formData = new FormData();
      formData.append('data', JSON.stringify(this.changeStatusFormModel));
      service[this.data.methodName](formData).subscribe((res: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        this.changeStatusFormModel = new ChangeStatusFormModel()
        Swal.fire({
          title: this.data.successMsg,
          text: this.data.successMsgDesc,
          imageUrl: './assets/images/icons/success.svg',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      }, (error: any) => {
        this.loading = false;
      });
    }
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
}
